let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iGQiJ")).then(() => parcelRequire('gyipB'));